import React from 'react'
import { FaCheckCircle, FaExclamationCircle, FaTimesCircle } from 'react-icons/fa'
import styled from 'styled-components'

type StatusTone = 'success' | 'warning' | 'error'

interface Props {
  label: string
  tone: StatusTone
}

const ICON = {
  success: FaCheckCircle,
  warning: FaExclamationCircle,
  error: FaTimesCircle
} as const

export const ElsterToggleTitle: React.FC<Props> = ({ label, tone }) => {
  const Icon = ICON[tone]

  return (
    <TitleRow>
      <StatusIcon $tone={tone} aria-hidden>
        <Icon />
      </StatusIcon>
      {label}
    </TitleRow>
  )
}

const TitleRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

const StatusIcon = styled.span<{ $tone: StatusTone }>`
  display: inline-flex;
  color: ${({ theme, $tone }) => theme.colors[$tone]};
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  flex-shrink: 0;
`
